import { ProfessionalDailyWorkloadReport } from 'presentation/app/modules/ProfessionalReportDailyWorkload/pages';
import React from 'react';

export const MakeAProfessionalReportDailyWorkload: React.FC = () => {
  return <ProfessionalDailyWorkloadReport />;
};
